import { component } from 'picoapp';
// import srraf from 'srraf';
import { on, findOne, getRect } from '@/utils';

export default component((node, ctx) => {

  // const header = findOne('.site-header');
  // const menu = findOne('.nav-menu');

  // srraf((viewport, timestamp) => {
  //   const rect = getRect(node);
  //   const offset = header.offsetHeight - (rect.y + rect.height);
  //   menu.style.setProperty('--sub-menu-offset', `${offset}px`);
  // }).update();

  on('click', 'a[href="#"]', event => {
    event.preventDefault()
  }, node);

  on('click', '.nav-toggle', event => {
    document.body.classList.toggle('nav-active');
  });

});